/**
 * Copyright (c) 2022, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

import { useContext } from "react";
import { ConfigContext, ConfigContextInterface } from "../contexts";
import { ConfigInterface } from "../models";

/**
 * Hook to access the application config.
 */
export const useConfig = (): ConfigInterface => {

    const context: ConfigContextInterface = useContext(ConfigContext);

    if (context === undefined) {
        throw new Error("useConfig must be used within a ConfigProvider");
    }

    return {
        deployment: context.deployment
    };
};
